var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopBlueVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1273,
    height: 239,
    viewBox: "0 0 1273 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1507.11 269.338L793.289 30.5508C610.115 -30.7254 401.56 8.78604 244.361 147.82C128.455 250.328 32.3367 424.755 1.82192 485.232",
    stroke: "#3AC2CE",
    strokeWidth: 3.47222,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopBlueVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop_blue_vector.e99d2aed5daa3a593452a705f6b520b0.svg";